import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router';

import { useAccount } from '@/api/admin';
import { QuickFeedback } from '@/components/Feedback/QuickFeedback';
import { extractLanguage } from '@/configuration/lang/lang';
import { RIO_MARKETPLACE_URL } from '@/lib/constants';
import { formatUrl } from '@/lib/utils';
import { DEFAULT_ROUTE } from '@/routes/Router';
import { useUserStore } from '@/stores/userStore';

import { trackButtonClick } from '../utils/analytics';

export const OrderComplete = () => {
    const { setAccount } = useUserStore();
    const navigate = useNavigate();
    const { data: account } = useAccount();
    const intl = useIntl();
    const userLanguage = extractLanguage(intl.locale);

    const handleGoDashboard = async () => {
        trackButtonClick('go_to_dashboard', DEFAULT_ROUTE);

        if (account) {
            setAccount(account);
            navigate(DEFAULT_ROUTE);
        }
    };

    const handleGoMarketplace = () => {
        const marketplaceLink = formatUrl(RIO_MARKETPLACE_URL, userLanguage);
        trackButtonClick('go_to_marketplace', marketplaceLink);
        window.location.href = marketplaceLink;
    };

    return (
        <div className='display-flex flex-column align-items-center'>
            <div className='border-color-gray width-100pct max-width-700 margin-bottom-15 rounded border bg-white padding-25'>
                <div className='display-flex flex-column gap-3 text-center'>
                    <span className='rioglyph rioglyph-ok-sign text-color-primary' style={{ fontSize: '90px' }} />
                    <span className='text-size-h1 text-color-dark'>
                        <FormattedMessage id='onboarding.congratulations.title' />
                    </span>
                    <span className='text-color-dark'>
                        <FormattedMessage id='onboarding.congratulations.description' />
                    </span>
                </div>
                <div className='margin-top-20 btn-toolbar justify-content-center'>
                    <Button onClick={handleGoMarketplace} type='button' className='btn btn-default'>
                        <span className='text-capitalize'>
                            <FormattedMessage id='onboarding.goToMarketplace' />
                        </span>
                    </Button>
                    <Button onClick={handleGoDashboard} type='button' className='btn btn-primary'>
                        <span className='text-capitalize'>
                            <FormattedMessage id='onboarding.goToMANeMSP' />
                        </span>
                    </Button>
                </div>
                <QuickFeedback />
            </div>
        </div>
    );
};
